.textAreaContainer {
  width: 100%;
  box-sizing: border-box;

  .textArea {
    padding: 12px;
    width: 100%;
    box-sizing: border-box;
    font-family: Galano Grotesque, Segoe UI, sans-serif;
  }

  .noBorder {
    border: none;
  }

  * {
    resize: none;
  }
}
